// extracted by mini-css-extract-plugin
export default {"framework-selector":"T_cv d-flex","framework-selector__icon":"T_cw","framework-selector__option":"T_cx p-2 flex-grow-1 ml-2","framework-selector__option--selected":"T_cy"};